
import * as z from 'zod';

// Profile form schema
export const profileFormSchema = z.object({
  name: z.string().min(2, { message: 'Namnet måste vara minst 2 tecken.' }),
  email: z.string().email({ message: 'Ogiltig e-postadress.' }),
  company: z.string().optional(),
  title: z.string().optional(),
  phone: z.string().optional(),
  address: z.string().optional(),
  avatar_url: z.string().optional(),
});

export type ProfileFormValues = z.infer<typeof profileFormSchema>;
